export const refs = {
  form: document.querySelector('.js-search-form'),
  weatherContainer: document.querySelector('.js-weather-wrapper'),
};
